import React from 'react'
import classnames from 'classnames'

import StoreLocator from '../svg/storelocator/storelocator.svg'
import ProductLocator from '../svg/storelocator/productlocator.svg'

export default class Locators extends React.Component {

    static defaultProps = {
        storeLocatorLabel: 'Store locator',
        productLocatorLabel: 'Product locator'
    }

    state = {
        target: 'storelocator'
    }

    render() {

        const { storeLocatorLabel, productLocatorLabel } = this.props
        const { target } = this.state

        return (
            <React.Fragment>
                <div className="locator">
                    <div className="tabs">
                        <ul>
                            <li className={classnames({ active: target === 'storelocator'})}>
                                <button
                                    onClick={() => this.setState({ target: 'storelocator' })}
                                >
                                    {storeLocatorLabel}
                                </button>
                            </li>
                            <li className={classnames({ active: target === 'productlocator'})}>
                                <button
                                    onClick={() => this.setState({ target: 'productlocator' })}
                                >
                                    {productLocatorLabel}
                                </button>
                            </li>
                        </ul>
                    </div>

                    {target === 'storelocator' && (
                        <div className="image storelocator">
                            <StoreLocator />
                        </div>
                    )}

                    {target === 'productlocator' && (
                        <div className="image productlocator">
                            <ProductLocator />
                        </div>
                    )}
                </div>
            </React.Fragment>
        )
    }
}
